export default __webpack_public_path__ + "static/media/sample_igloo_lock_id.46f89260.jpeg";